/**
 * Different modes of the Melascope.
 */
export enum MelascopeMode {
  PoweredOff = 0,
  PoweredOn = 1,
}
